import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ApiConnect from "../../../../Utils/ApiConnect";
import { connect } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import DeletePop from "../../../Components/DeletePop";
import {
  CustomerMembership,
  CustomerDiscountGroup,
  CustomerCustomersList,
} from "../../../../redux/actions/Modules.Action";
import AutoComplete from "../../../Components/AutoComplete";
import { toast } from "react-toastify";
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      triggerModal: false,
      selectedId: false,
      customername: "",
      customerid: "",
      discount: "",
      formError: false,
      btnDisable: false,
    };
    this.columns = [
      {
        key: "name",
        text: "Customer",
        cell: (record) => {
          return (
            <React.Fragment>
              <div className="d-inline">
                {record.name}{" "}
                <span className="material-icons-outlined text-success fs-15">
                  verified
                </span>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        key: "id",
        text: "Contact",
      },

      {
        key: "discount",
        text: "Discount",
      },
      {
        key: "last_invoice",
        text: "Last Invoice",
      },
      {
        key: "last_visit",
        text: "Last Update",
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,
        sortable: false,
        align: "center",
        cell: (record) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: record.id, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchMembers();
    this.fetchDiscountAndMember();
  }
  fetchMembers = () => {
    ApiConnect.get("/Members/Information/MembershipList")
      .then((response) => {
        this.props.CustomerMembership(response.data);
      })
      .catch((error) => console.log(error));
  };
  fetchDiscountAndMember() {
    ApiConnect.get("/Members/Information/CustomerList")
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
    ApiConnect.get("/Members/Information/DiscountGroup")
      .then((response) => {
        this.props.CustomerDiscountGroup(response.data);
      })
      .catch((error) => console.log(error));
  }

  autocompleteAction = (data) => {
    this.setState({ customername: data.name, customerid: data.id });
  };
  handleSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.customername);
    Fdata.append("contact", this.state.customerid);
    Fdata.append("discount", this.state.discount);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewMembership",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            showModal: false,
            triggerModal: false,
            selectedId: false,
            customername: "",
            customerid: "",
            discount: "",
            formError: false,
            btnDisable: false,
          });
          this.fetchMembers();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Membership</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                config={this.config}
                records={this.props.Membership}
                columns={this.columns}
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Member</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={(e) => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Customer Contact</label>
                      {this.props.CustomerList ? (
                        <AutoComplete
                          name="Customer"
                          action={this.autocompleteAction}
                          placeHolder="Customer Name"
                          items={this.props.CustomerList}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">Discount Group</label>
                      <label className="col-12">
                        <select
                          className="form-control"
                          name="group"
                          value={this.state.discount}
                          onChange={(e) =>
                            this.setState({ discount: e.target.value })
                          }
                        >
                          <option>Select Group</option>
                          {this.props.Discount.map((group, index) => (
                            <option value={group.id} key={`${group}${index}`}>
                              {group.name}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeleteMembership?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchMembers}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    Membership: state.Customer.Membership,
    Discount: state.Customer.Discount,
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerMembership, CustomerDiscountGroup, CustomerCustomersList }
)(index);
